if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async getCartElement() {
        let cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');

        if (cartDrawer) {
          if (!customElements.get('cart-drawer')) {
            try {
              await customElements.whenDefined('cart-drawer');
              cartDrawer = document.querySelector('cart-drawer');
            } catch (e) {
              console.error('[ProductForm] Error waiting for cart-drawer:', e);
            }
          }

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            return cartDrawer;
          }
        }

        if (cartNotification && typeof cartNotification.renderContents === 'function') {
          return cartNotification;
        }

        return null;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.submitButtonText) {
          this.originalButtonText = this.submitButtonText.textContent;
          this.submitButtonText.textContent = 'Agregando';
        }

        const cart = await this.getCartElement();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            const currentCart = await this.getCartElement();
            if (!currentCart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = window.CartPerformance?.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                if (startMarker && window.CartPerformance) {
                  window.CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                }
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => setTimeout(() => currentCart.renderContents(response)),
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              currentCart.renderContents(response);
            }
          })
          .catch((e) => console.error('[ProductForm] Fetch error:', e))
          .finally(async () => {
            const finalCart = await this.getCartElement();
            this.submitButton.classList.remove('loading');
            if (finalCart && finalCart.classList.contains('is-empty')) finalCart.classList.remove('is-empty');
            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
              if (this.submitButtonText && this.originalButtonText) {
                this.submitButtonText.textContent = this.originalButtonText;
              }
            }
            this.querySelector('.loading__spinner').classList.add('hidden');
            window.CartPerformance?.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          const customText = this.submitButton.dataset.addToCartText;
          this.submitButtonText.textContent = customText || window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
